import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFolderMove = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "32px",
	height: "32px",
	viewBox: "0 0 32 32",
	id: "icon",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .cls-1 {\n        fill: none;\n      }\n    " }) }),
		/* @__PURE__ */ _jsx("polygon", { points: "18 13 16.59 14.41 19.17 17 10 17 10 19 19.17 19 16.59 21.59 18 23 23 18 18 13" }),
		/* @__PURE__ */ _jsx("path", { d: "M11.1716,6l3.4142,3.4142L15.1716,10H28V26H4V6h7.1716m0-2H4A2,2,0,0,0,2,6V26a2,2,0,0,0,2,2H28a2,2,0,0,0,2-2V10a2,2,0,0,0-2-2H16L12.5858,4.5858A2,2,0,0,0,11.1716,4Z" }),
		/* @__PURE__ */ _jsx("rect", {
			id: "_Transparent_Rectangle_",
			"data-name": "<Transparent Rectangle>",
			className: "cls-1",
			width: 32,
			height: 32
		})
	]
});
const ForwardRef = forwardRef(SvgFolderMove);
export { ForwardRef as ReactComponent };
